import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.define-properties";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry, Nick Cattaneo

 Description:
 */
import Immutable from 'immutable';
import * as actions from './actions';
import * as formActions from '../forms/actions';
import FieldRecord from '../../records/FieldRecord';
import getFieldKey from '../../form/get-field-key';

var fieldsReducer = function fieldsReducer() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Immutable.Map();

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      _ref$payload = _ref.payload,
      payload = _ref$payload === void 0 ? {} : _ref$payload;

  switch (type) {
    case actions.FIELD_DEFINE:
      {
        var fieldKey = getFieldKey(payload);
        return fields.has(fieldKey) ? fields : Immutable.Map([[fieldKey, new FieldRecord(Object.assign({}, payload, {
          fieldKey: fieldKey
        }))]]).merge(fields);
      }

    case actions.FIELD_DELETE:
      return fields["delete"](getFieldKey(payload));

    case actions.FIELD_APPLY_RESET:
      return fields.update(getFieldKey(payload), function (field) {
        return field.merge({
          value: field.initialValue,
          dirty: false
        });
      });

    case actions.FIELD_APPLY_CHANGE:
      {
        var _fieldKey = getFieldKey(payload);

        if (payload.showError) {
          payload.serverMessage = '';
        }

        return fields.update(_fieldKey, function (field) {
          return field ? field.merge(payload) : new FieldRecord(payload);
        });
      }

    case actions.FIELDS_APPLY_CHANGES:
      {
        return fields.merge(payload.reduce(function (collection, _ref2) {
          var fieldKey = _ref2.fieldKey,
              fieldProps = _objectWithoutProperties(_ref2, ["fieldKey"]);

          var $field = fields.get(fieldKey);
          $field && (collection[fieldKey] = $field.merge(_objectSpread(_objectSpread({}, fieldProps), {}, {
            deltaCount: $field.deltaCount + 1
          })));
          return collection;
        }, {}));
      }

    case actions.FIELDS_CLEAR_ERRORS:
      return fields.map(function (field) {
        return field.formId === payload.formId ? field.merge({
          errorMessage: '',
          showError: false,
          serverMessage: ''
        }) : field;
      });

    case formActions.FORM_DELETE:
      return fields.filter(function (field) {
        return field.formId !== payload.formId;
      });

    default:
      return fields;
  }
};

export default fieldsReducer;